<div nz-row [nzGutter]="[30, 30]">
  <div nz-col nzXs="24" [nzLg]="horizontalMode ? 12 : 24">
    <div
    *ngIf="user"
    class="d-flex tw-gap-2.5"
    [class.align-items-start]="changePatientName"
    [class.align-items-center]="!changePatientName">
    <div class="imageContainer">
      <div class="mr-xs">
        <app-avatar-user
          [image]="user.profileImageURL"
          [name]="user.name"
          [lastname]="user.lastname"
          [width]="85"
          [fontSize]="'30px'"></app-avatar-user>
      </div>
    </div>
    <div class="truncate nameContainer">
      <h3
        nz-popover
        nzPopoverTitle=""
        [nzPopoverContent]="!changePatientName ? 'Clic para modificar' : 'Clic para cancelar'"
        (click)="changePatientName= !changePatientName"
        class="name text-title-md mb-xs cursor-pointer pos-relative tw-w-full d-flex align-items-center">
        <p class="truncate patient-name">{{ user.name }} {{ user.lastname }}</p>

        <img loading="lazy" class="icon-edit-ingredient" [src]="!changePatientName ? './../../../assets/images/icons/icons8-lapiz-100.png' : './../../../assets/images/icons/icons8-eliminar-40.png'" alt="">
      </h3>
      <div
        *ngIf="changePatientName"
        @fadeInAnimation
        class="mr-xs mb-xlg"
        style="position: relative">
        <p class="input-label-form">Nombre</p>
        <input @fadeInAnimation [(ngModel)]="user.name" nz-input />
        <p class="input-label-form mt-xs">Apellidos</p>
        <input @fadeInAnimation [(ngModel)]="user.lastname" nz-input />
        <span
          style="position: absolute; bottom: -23px; right: 5px"
          class="d-flex align-items-center">
          <p class="text-link" (click)="onChangePatientName()">Guardar</p>
        </span>
      </div>
      <div class="data-row">
        <div class="d-flex flex-column justify-content-center">
          <p class="label text-subtitle-bold-upper">GÉNERO</p>
          <p class="text-regular-14" *ngIf="!user.gender">Sin especificar</p>
          <p class="text-regular-14" *ngIf="user.gender">
            <img loading="lazy"
              *ngIf="user.gender === genderEnum.FEMALE"
              class="gender-class"
              src="./../../../assets/images/icons/icons8-female-100.png"
              alt=""
              />
            <img loading="lazy"
              *ngIf="user.gender === genderEnum.MALE"
              class="gender-class"
              src="./../../../assets/images/icons/icons8-male-100.png"
              alt=""
              />
          </p>
        </div>
        <div>
          <p class="label text-subtitle-bold-upper">EDAD</p>
          <p class="text-regular-14" *ngIf="user.birthday">
            {{ user.birthday | getAge }}
          </p>
          <p class="text-regular-14" *ngIf="!user.birthday">Sin especificar</p>
        </div>
      </div>
    </div>
  </div>
  </div>
  <div nz-col nzXs="24" [nzLg]="horizontalMode ? 12 : 24">
    <div class="measures" *ngIf="indicators" @fadeInAnimation>
      <div class="data-col">
        <p class="label text-subtitle-bold-upper">ALTURA</p>
        <p class="measure text-regular-14">
          {{ indicators?.measurements.high?.value.toFixed(2) }}
          {{ indicators?.measurements.high?.measureUnit?.symbol_es }}
        </p>
        <p
          class="measure text-link"
          (click)="onGoToMeasurements()"
          *ngIf="!indicators?.measurements?.high?.value.toFixed(2) && userLogged?.experts">
          agregar
        </p>
        <p
          class="measure"
          *ngIf="!indicators?.measurements?.high?.value.toFixed(2) && userLogged?.patients">
          no registrado
        </p>
      </div>
      <div class="data-col">
        <p class="label text-subtitle-bold-upper">PESO</p>
        <p class="measure text-regular-14">
          {{ indicators?.measurements?.weight?.value.toFixed(2) }}
          {{ indicators?.measurements?.weight?.measureUnit?.symbol_es }}
        </p>
        <p
          class="measure text-link"
          (click)="onGoToMeasurements()"
          *ngIf="!indicators?.measurements?.weight?.value.toFixed(2) && userLogged?.experts">
          agregar
        </p>
        <p
          class="measure"
          *ngIf="!indicators?.measurements?.weight?.value.toFixed(2) && userLogged?.patients">
          no registrado
        </p>
      </div>
      <div class="data-col">
        <p class="label text-subtitle-bold-upper">IMC</p>
        <p class="measure text-regular-14">
          {{ indicators?.measurements?.imc?.value.toFixed(2) }}
        </p>
        <p
          class="measure text-link"
          (click)="onGoToDiagnostic()"
          *ngIf="!indicators?.measurements?.imc?.value.toFixed(2) && userLogged?.experts">
          agregar
        </p>
        <p
          class="measure"
          *ngIf="!indicators?.measurements?.imc?.value.toFixed(2) && userLogged?.patients">
          no registrado
        </p>
      </div>
    </div>
  </div>
</div>
<ng-container *ngIf="showActions">
  <div
  class="detail mt-lg"
  *ngIf="indicators && indicators.servicePatient as service">
  <p class="label text-subtitle-bold-upper mb-xs">
    Meta del paciente

    <img
      loading="lazy"
      class="icon-edit-ingredient tw-cursor-pointer"
      alt=""
      *ngIf="this.userAuthRole !== this.roles.PATIENT"
      nzPopoverTitle="" [nzPopoverContent]="!addPatientGoal ? 'Clic para modificar' : 'Clic para cancelar'"
      [src]="!addPatientGoal ? './../../../assets/images/icons/icons8-lapiz-100.png' : './../../../assets/images/icons/icons8-eliminar-40.png'"
      (click)="addPatientGoal= !addPatientGoal" nz-popover=""
    >
  </p>
  <div class="d-flex align-items-end" *ngIf="service.patientGoal && !addPatientGoal">
    <p
      class="text-info"
      appExpandText>
      {{ service.patientGoal }}
    </p>
  </div>
  <p
    class="text-link"
    *ngIf="!service.patientGoal && !addPatientGoal && userLogged?.experts"
    (click)="addPatientGoal= true">
    Agregar meta del paciente
  </p>
  <p
    class="text-info"
    *ngIf="!service.patientGoal && !addPatientGoal && userLogged?.patients">
    No registrada
  </p>
  <div
    *ngIf="addPatientGoal && service"
    @fadeInAnimation
    class="mr-xs"
    style="position: relative">
    <textarea
      @fadeInAnimation
      rows="4"
      [(ngModel)]="service.patientGoal"
      nz-input></textarea>
    <span
      style="position: absolute; bottom: -23px; right: 5px"
      class="d-flex align-items-center">
      <p class="text-link" (click)="onSavePatientGoal()">Guardar</p>
    </span>
  </div>
</div>
<div class="detail mt-lg">
  <p class="label text-subtitle-bold-upper mb-xs">Objetivo clínico final</p>
  <p
    class="text-info"
    *ngIf="!patientClinicalObjectives || patientClinicalObjectives.length === 0">
    Sin objetivos clínicos.
  </p>
  <div nz-row [nzGutter]="[0, 7]">
    <div nz-col *ngFor="let objective of patientClinicalObjectives">
      <nz-tag
        class="tag"
        [style.background-color]="objective | setClinicalObjectiveColor">{{ objective.text }}</nz-tag>
    </div>
  </div>
</div>

<div
  class="d-flex justify-content-between mt-lg"
  *ngIf="userType === 'patient'">
  <div class="tw-w-full">
    <p class="text-info mb-xxs">
      Selecciona un servicio para ver la información
    </p>
    <nz-select
      [(ngModel)]="serviceName"
      nzPlaceHolder="Selecciona que servicio mostrar"
      style="width: 100%"
      (ngModelChange)="onEmitChangeServiceExpert($event)">
      <ng-container *ngFor="let service of servicesByPatient$ | async">
        <nz-option
          [nzValue]="service.expertId"
          [nzLabel]="service.expertName +
          ' - ' +
          (service.clinicObjectives.length> 0
          ? service.clinicObjectives
          : '(sin objetivos)')
          "
          ></nz-option>
      </ng-container>
    </nz-select>
  </div>
</div>

<div
  class="d-flex justify-content-between mt-lg tw-w-full"
  *ngIf="userType !== 'patient'">
  <button
    class="tw-w-full mr-md btn-add-appointment"
    nz-button
    nzType="primary"
    (click)="onEmitViewModalCreateAppointment()"
    *ngIf="!appointmentId">
    <i nz-icon nzType="plus" nzTheme="outline"></i> Crear cita
  </button>

  <button
    class="tw-w-full"
    nz-button
    nzType="primary"
    (click)="onEmitViewModalCreateNote()"
    *ngIf="this.service">
    <i nz-icon nzType="plus" nzTheme="outline"></i> Crear Nota
  </button>
</div>
</ng-container>
